import React from 'react';
import { DaoSettings } from '../organisms';
import { SettingsTemplate } from '../templates';

export function DaoSettingsPage() {
  return (
    <SettingsTemplate>
      <DaoSettings />
    </SettingsTemplate>
  );
}
